// ImageUtils.js
// Improved EXIF metadata reader that safely handles unsupported formats (e.g., TIFF)
export const readImageMetadata = async file => {
  const name = file.name.toLowerCase();
  // Bypass EXIF for TIFF files (HTMLImage can't decode them)
  if (name.endsWith(".tif") || name.endsWith(".tiff")) {
    return null;
  }

  return new Promise(resolve => {
    const reader = new FileReader();

    // If FileReader errors, resolve with null
    reader.onerror = () => resolve(null);

    reader.onload = event => {
      const img = new Image();

      // If the image fails to load (e.g., unsupported format), resolve with null
      img.onerror = () => resolve(null);

      img.onload = () => {
        if (img.exifdata && img.exifdata.DateTimeOriginal) {
          const exifDate = new Date(img.exifdata.DateTimeOriginal);
          resolve(exifDate.toISOString().split("T")[0]);
        } else {
          resolve(null);
        }
      };

      img.src = event.target.result;
    };

    reader.readAsDataURL(file);
  });
};
